<div class="collectionTitle">
  <h1> REDEPLOYMENT ACCESS PORTAL </h1>
</div>

@if(entity){

<div class="collection-section">
  @for(collection of entity.data; track collection){
    <div>
      <kendo-card class="collectionCard">
        <kendo-card-header class="collectionHeader">
          {{collection.collection_Name}}
        </kendo-card-header>
        <kendo-card-body>
          <div style="padding: 0px 10px;">
            <br />
            <div id="collectionContainer">
              <div class="collection-item" style="background-image: url({{collection.collectionImage}}); background-size: contain; background-repeat: no-repeat; background-position: center;">
              </div>
            </div>
            </div>
        </kendo-card-body>
        <kendo-card-footer style=" color: white; background-color: #08408b; opacity: 85%;">
          <button kendoButton class="viewBtn" (click)="redirectToCollection(collection.collectionId, collection.collection_Name)" title="VIEW">VIEW</button>
        </kendo-card-footer>
      </kendo-card>
      </div>
  }
  </div>

}

<kendo-stacklayout orientation="vertical" style="width:100%">

  @if (openTimeout) {
  <kendo-dialog title="Attention!" [animation]="true" (close)="closeTimeoutDialog()">
    <p>
      Certain items you've reserved went past the 30 minute time cap: <br>
    </p>

    @for(item of timedOutCartItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.itemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    @for(item of timedOutCartMiscItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.miscellaneousItemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    <p>
      The other items in your cart have been removed and returned to available status. <br>
      Please re-add your items and checkout within the 30 minute mark.
    </p>

    <kendo-dialog-actions>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="acknowledgeTimedOutItems()" [svgIcon]="dialogYes">
        Acknowledge
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="acknowledgeTimedOutItems()">
        Acknowledge
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>
